//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { InstagramPostDetailsDefaultsActions } from '@instagram-account/redux/post-details/defaults/instagramPostDetailsDefaultsActions';
import { IInstagramPostDetailsDefaultsState, INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS } from '@instagram-account/redux/post-details/defaults/instagramPostDetailsDefaultsModel';

const initialState: IInstagramPostDetailsDefaultsState = {
  currentDefaults: {},
  newDefaults: {},
  flags: {
    isSavingDefaults: false,
    isFetchingDefaults: false,
  },
};

export default function InstagramPostDetailsDefaultsReducer(
  state: IInstagramPostDetailsDefaultsState = initialState,
  action: InstagramPostDetailsDefaultsActions,
): IInstagramPostDetailsDefaultsState {
  switch (action.type) {
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.REQUEST_DEFAULTS: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingDefaults: true,
        },
      };
    }
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.RECEIVE_DEFAULTS_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingDefaults: false,
        },
        currentDefaults: action.currentDefaults,
        newDefaults: action.currentDefaults,
      };
    }
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.RECEIVE_DEFAULTS_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingDefaults: false,
        },
        currentDefaults: initialState.currentDefaults,
      };
    }
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.SET_DEFAULT_USER_ID: {
      return {
        ...state,
        newDefaults: {
          ...state.newDefaults,
          defaultNotificationUserId: action.defaultNotificationUserId,
        },
      };
    }
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.CLEAR_DEFAULT_USER_ID: {
      return {
        ...state,
        newDefaults: {
          ...state.newDefaults,
          defaultNotificationUserId: undefined,
        },
      };
    }
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.SET_DEFAULT_POST_TIME: {
      return {
        ...state,
        newDefaults: {
          ...state.newDefaults,
          defaultPostTime: action.defaultPostTime,
        },
      };
    }
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.CLEAR_DEFAULT_POST_TIME: {
      return {
        ...state,
        newDefaults: {
          ...state.newDefaults,
          defaultPostTime: {
            hour: undefined,
            minute: undefined,
          },
        },
      };
    }
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.SET_DEFAULT_PUBLISHING_STRATEGY: {
      return {
        ...state,
        newDefaults: {
          ...state.newDefaults,
          defaultPublishingStrategy: action.defaultPublishingStrategy,
        },
      };
    }
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.REQUEST_SAVE_DEFAULTS: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingDefaults: true,
        },
      };
    }
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.RECEIVE_SAVE_DEFAULTS_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingDefaults: false,
        },
      };
    }
    case INSTAGRAM_POST_DETAILS_DEFAULTS_ACTIONS.RECEIVE_SAVE_DEFAULTS_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isSavingDefaults: false,
        },
      };
    }
  }
  return state;
}
